export default __webpack_public_path__ + "static/facts_1-ebbbfe55c1c24485acb09d3d0cdf414a.webp";